export default __webpack_public_path__ + "static/lolipop-2638fe4f872ec19096027351d6bf3583.png";